import { useEffect } from 'react';

import config from '@/config';
import useQuery from '@/hooks/useQuery';
import ArtistSuggestionLoader from '@/shared-components/loader/special-loaders/ArtistSuggestionLoader';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './virtual-list';

import './index.css';

export default function Suggestions({ query, addTag, formState, selectedIndex, onSuggestionsChange }) {
  const { loading, queryData, loadMoreData } = useQuery("post_search_users", `${config.apis.api.url}/search/user`, query, {
    injectToken: true,
  });

  // whenever queryData changes, lift the raw array up
  useEffect(() => {
    const items = queryData?.data?.data || [];
    onSuggestionsChange(items);
  }, [queryData, onSuggestionsChange]);

  return (
    <div className="post-tags__search-suggestions">
      {
        loading ? 
          <ArtistSuggestionLoader className="post-tags__search-spinner" />
          : queryData.data.data.length === 0 ? 
            <Text className="post-tags__search-no-suggestions font-size-small" paragraph>
              No results found for "<span>{query.q}</span>".
            </Text>
            : 
            <VirtualList 
              key={queryData.queryString} 
              items={queryData.data} 
              onLoadMore={loadMoreData} 
              addTag={addTag}
              formState={formState}
              selectedIndex={selectedIndex}
            />
      }
    </div>
  );
}
